// validations
import * as yup from "yup";

const validations = yup.object().shape({
  email: yup.string().email("Campo inválido").required("Campo não-preenchido"),
});

export default validations;
